import * as tslib_1 from "tslib";
import { BlockScrollStrategy, ScrollDispatcher, ScrollStrategyOptions, ViewportRuler, } from '@angular/cdk/overlay';
import { NgZone, } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/scrolling";
import * as i2 from "@angular/common";
var UiBlockScrollStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(UiBlockScrollStrategy, _super);
    function UiBlockScrollStrategy(viewportRuler, document) {
        var _this = _super.call(this, viewportRuler, document) || this;
        _this.document = document;
        return _this;
    }
    /** Unblocks page-level scroll while the attached overlay is open. */
    UiBlockScrollStrategy.prototype.disable = function () {
        _super.prototype.disable.call(this);
        var html = this.document.documentElement;
        var body = this.document.body;
        if (body.style.scrollBehavior === '') {
            delete body.style.scrollBehavior;
        }
        if (html.style.scrollBehavior === '') {
            delete html.style.scrollBehavior;
        }
    };
    return UiBlockScrollStrategy;
}(BlockScrollStrategy));
export { UiBlockScrollStrategy };
var UiScrollStrategyOptions = /** @class */ (function (_super) {
    tslib_1.__extends(UiScrollStrategyOptions, _super);
    function UiScrollStrategyOptions(scrollDispatcher, ngZone, 
    // tslint:disable-next-line: naming-convention
    __viewportRuler, 
    // tslint:disable-next-line: naming-convention
    __document) {
        var _this = _super.call(this, scrollDispatcher, __viewportRuler, ngZone, __document) || this;
        _this.__viewportRuler = __viewportRuler;
        _this.__document = __document;
        _this.block = function () { return new UiBlockScrollStrategy(_this.__viewportRuler, _this.__document); };
        return _this;
    }
    UiScrollStrategyOptions.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UiScrollStrategyOptions_Factory() { return new UiScrollStrategyOptions(i0.ɵɵinject(i1.ScrollDispatcher), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.ViewportRuler), i0.ɵɵinject(i2.DOCUMENT)); }, token: UiScrollStrategyOptions, providedIn: "root" });
    return UiScrollStrategyOptions;
}(ScrollStrategyOptions));
export { UiScrollStrategyOptions };
